import { NewUserModal } from 'components';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createUser } from 'actions/User';
import { User, Location, LocationType } from 'model'
import { createStructuredSelector } from 'reselect';
import { selectIsSubmitting } from 'selectors/Common';
import { RootState, ListView } from 'model/state';
import { selectAccountId, selectUserId, selectLoggedUser } from 'selectors/Auth';
import { selectUserLocations } from 'selectors';
import { fetchUserLocations } from 'actions';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createUser: (user: User) => dispatch(createUser(user)),
  fetchUserLocations: (userId: string, types: LocationType[], page: number, search?: string) => dispatch(fetchUserLocations(userId, types, page, search, true)),
});

type SelectedValues = {
  isSubmitting: boolean,
  accountId?: string,
  userLocations: ListView<Location>,
  userId?: string | null,
  loggedUser?: User,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  isSubmitting: selectIsSubmitting(),
  accountId: selectAccountId(),
  userLocations: selectUserLocations(),
  userId: selectUserId(),
  loggedUser: selectLoggedUser(),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewUserModal);